import React, { useState, useEffect } from "react";
import { useRouter } from "next/compat/router";
import dynamic from "next/dynamic";
import { Builder } from "@builder.io/react";
import { BuilderComponent } from "@builder.io/react";
import { builderClient } from "../../../utils/builder";
import { toolkitColors } from "@/utils/constants";

export const FooterBuilder = () => {
  const [builderContentJson, setBuilderContentJson] = useState(null);

  const router = useRouter();

  useEffect(() => {
    const isImpactOrCharityPage =
      router.asPath.startsWith("/impact") ||
      router.asPath.startsWith("/charity");

    builderClient
      .get("footer", {
        userAttributes: {
          urlPath: router.asPath,
          impactOrCharityPage: isImpactOrCharityPage,
        },
      })
      .promise()
      .then(setBuilderContentJson);
  }, [router.asPath]);

  return <BuilderComponent model="footer" content={builderContentJson} />;
};

const TickerBanner = dynamic(async () => {
  return (await import("./TickerBanner")).default;
});

Builder.registerComponent(TickerBanner, {
  name: "Impact banner",
  inputs: [
    {
      name: "enableText",
      type: "boolean",
      default: false,
      helperText:
        "Enable to enter text. Disable to sync total impact or add numbers for a ticker",
    },
    {
      name: "bannerText",
      type: "string",
      helperText: "Text to be entered on the banner (Character limit - 16)",
      onChange: (options) => {
        if (options.get("text").toString().length > 16) {
          options.set("text", options.get("text").toString().slice(0, 16));
          alert(`Maximum number of characters is 16`);
        }
      },
      showIf: `options.get('enableText') == true`,
    },
    {
      name: "syncTotalImpact",
      type: "boolean",
      default: true,
      helperText:
        "Enable to use the current total impact. This value will automatically update daily",
      showIf: `!options.get('enableText')`,
    },
    {
      name: "from",
      type: "number",
      helperText:
        "Start value for the ticker (Only numbers are accepted. Character limit - 7)",
      onChange: (options) => {
        if (options.get("from").toString().length > 7) {
          options.set("from", options.get("from").toString().slice(0, 7));
          alert(`Maximum number of characters is 7`);
        }
      },
      showIf: `!options.get('enableText') && !options.get('syncTotalImpact')`,
    },
    {
      name: "to",
      type: "number",
      helperText:
        "End value for the ticker (Only numbers are accepted. Character limit - 7)",
      onChange: (options) => {
        if (options.get("to").toString().length > 7) {
          options.set("to", options.get("to").toString().slice(0, 7));
          alert(`Maximum number of characters is 7`);
        }
      },
      showIf: `!options.get('enableText') && !options.get('syncTotalImpact')`,
    },
    {
      name: "header",
      type: "string",
      helperText:
        "Header text to be added below the banner (Character limit - 26)",
      onChange: (options) => {
        if (options.get("header").length > 26) {
          options.set("header", options.get("header").slice(0, 26));
          alert(`Maximum number of characters is 26`);
        }
      },
    },
    {
      name: "body",
      type: "longText",
      helperText: "Body text (Character limit - 370)",
      onChange: (options) => {
        if (options.get("body").length > 370) {
          options.set("body", options.get("body").slice(0, 370));
          alert(`Maximum number of characters is 370`);
        }
      },
    },
    {
      name: "backgroundColor",
      type: "string",
      defaultValue: "Silk",
      enum: toolkitColors,
      helperText: "Background color for the banner",
    },
    {
      name: "alignment",
      type: "string",
      defaultValue: "Left",
      enum: ["Left", "Centre"],
      helperText:
        "Choose whether the banner is left aligned or centrally aligned",
    },
  ],
});
